import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

function WageRatioChartTooltipInner (props) {
  if (!props) {
    return null
  }

  const budgetedWageRatio = !isNaN(parseFloat(props.budgeted_wage_ratio)) ? parseFloat(props.budgeted_wage_ratio) : 0
  const realizedWageRatio = !isNaN(parseFloat(props.realized_wage_ratio)) ? parseFloat(props.realized_wage_ratio) : 0

  return (
    <UI.Card>

      <UI.VerticalList>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='economy.pages.wage_ratio.legends.realized' />
          </UI.Text>
        )}
        >
          <UI.Text size='sm'>
            <Displays.WageRatio defaultValue={realizedWageRatio} defaultTargetValue={budgetedWageRatio}/>
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs'>
            <Translation name='economy.pages.wage_ratio.legends.budgeted' />
          </UI.Text>
        )}
        >
          <UI.Text size='base'>
            <Displays.WageRatio defaultValue={budgetedWageRatio}/>
          </UI.Text>
        </UI.WithSubtitle>

      </UI.VerticalList>

    </UI.Card>
  )
}

export default React.memo(WageRatioChartTooltipInner)
